// Core
import { useState, useCallback, useRef } from 'react';
import { useQuery } from 'react-query';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';

// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  SimpleGrid,
  InputGroup,
  InputLeftElement,
  Text,
  Input,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa6';

// Assets
import { textLang } from 'services/Lang';
import { apiService } from 'services/ApiService';
import { validateLoadMore, filterDate } from 'services/Utils';

// Components
import Row from './components/Row';

function Group({
  isLoadingPage,
  setIsLoadingPage,
  offset,
  setOffset,
  onNewButtonClicked,
  onBackClicked,
  refetchCountNewUserInMyGroups
}) {
  const history = useHistory();
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const limit = 8;
  const [data, setData] = useState([]);
  const [dataMeta, setDataMeta] = useState({total: 0, limit, offset}); 

  const { isFetching, refetch } = useQuery({
    queryKey: [
      'data',
      offset,
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        limit,
        offset,
      };

      const response = await apiService.getGroupsMe(params);
      if(offset === 0){
          setData(response.data);
      } else {
          setData([...data, ...response.data]);
      }
      setIsLoadingPage(false);
      setIsLoadingButton(false);
      setDataMeta(response.meta);

      refetchCountNewUserInMyGroups();

      return true;
    },
    retry: false,
  });

  const handleEditOpen = useCallback(
    (item) => {
      history.push(`/group-profile/${item.id}`);
    },
    [history],
  );

  const handleApprove = useCallback(
    (item) => {
      history.push(`/group-profile/${item.id}/users`);
    },
    [history],
  );

  const loadMore = async () => {
    setIsLoadingButton(true);
    setOffset(offset + limit);
  };

  return (
    <>
      { data?.length > 0 ? (
          <>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing="8px" opacity={ isLoadingPage ? '0.3' : '1' }>
              {data?.map(row => (
                <Row
                  key={row.id}
                  handleEditOpen={handleEditOpen}
                  handleApprove={handleApprove}
                  object={row}
                />
              ))}
            </SimpleGrid>

            { validateLoadMore(data, dataMeta) && (
              <Button variant="solid-md" onClick={loadMore} m="16px auto" display="block">
                Show More
              </Button>
            )}
          </>
          ) : (
            <Box
              width="100%"
              height="100vh"
              textAlign="center"
              position="relative">
              <Box 
                w="100%" 
                bottom="80px" 
                h="40vh" 
                overflow="hidden" 
                position="fixed"
                zIndex="3"
              >
                <Text px="10%" variant="title-lg" fontSize="24px">
                  { isFetching ? textLang('loading') : textLang('pay_note_4')}
                </Text>
              </Box>
            </Box>
          )
      }  

      <Box textAlign="center" zIndex="999" bg="#ffffff" position="fixed" bottom="0px" w="100%" h="124px" left="0" p="8px 15px">
        <Flex gap="8px">
          <Button onClick={onBackClicked}  variant="solid-lg" style={{width: '140px'}}>{textLang('back')}</Button>
          <Button 
            onClick={onNewButtonClicked}
            variant="button-lg" bg="#ff4133" w="100%" leftIcon={<FaPlus />}>{textLang('add')}</Button>
        </Flex>
      </Box>    
    </>
  );
}

export default Group;
